<h2 mat-dialog-title style="background: var(--ion-color-secondary-shade); color: white; margin: 0; padding: 12px 16px; border-radius: 4px 4px 0 0;">{{ dialogTitle }}</h2>

<mat-dialog-content>
  <p style="font-size: 13px; color: #666; margin-bottom: 8px;">{{ dialogDescription }}</p>
  <div style="background: #f5f5f5; border-radius: 6px; padding: 10px 14px; word-break: break-all;">
    <a [href]="data.url" target="_blank" style="font-size: 13px; color: #1976d2;">{{ data.url }}</a>
  </div>
</mat-dialog-content>

<mat-dialog-actions align="end" style="border-top: 1px solid var(--ion-color-secondary-shade);">
  <ion-button class="save-button" (click)="copyUrl()">{{ copied ? 'Copied!' : copyButtonLabel }}</ion-button>
  <ion-button class="save-button" (click)="close()">Close</ion-button>
</mat-dialog-actions>
